import {Box, Chip, Link, Stack, Typography} from '@mui/material';
import dayjs from 'dayjs';
import {ExamModule} from '@cp/model';

export interface ModuleViewInfoProps {
  examModule: ExamModule | null;
}

export default function ModuleViewInfo({examModule}: ModuleViewInfoProps) {
  if (!examModule) return null;

  return (
    <Stack gap={2} sx={{width: '100%'}}>
      <Typography variant="h6" sx={{color: '#1B263B', mb: 2}}>
        Module Information
      </Typography>
      <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2}}>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            ID
          </Typography>
          <Typography variant="body1" sx={{fontWeight: 500, fontFamily: 'monospace', fontSize: '0.875rem'}}>
            {examModule.id}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Name
          </Typography>
          <Typography variant="body1" sx={{fontWeight: 500}}>
            {examModule.name}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Level
          </Typography>
          <Chip label={examModule.level} size="small" />
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Subject
          </Typography>
          <Chip label={examModule.subject} size="small" color="primary" />
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Exam Board
          </Typography>
          <Typography variant="body1">{examModule.examBoard || 'None'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Questions Per Topic
          </Typography>
          <Typography variant="body1">{examModule.questionsPerTopic || 'Default'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Required Role
          </Typography>
          <Typography variant="body1">{examModule.requiredRole || 'None'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Attribution
          </Typography>
          <Typography variant="body1">{examModule.attribution || 'None'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Author
          </Typography>
          <Typography variant="body1">{examModule.author || 'None'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Source
          </Typography>
          {examModule.source ? (
            <Link href={examModule.source} target="_blank" rel="noopener noreferrer" variant="body1">
              open in new window
            </Link>
          ) : (
            <Typography variant="body1">None</Typography>
          )}
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            License
          </Typography>
          <Typography variant="body1">{examModule.license || 'None'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" sx={{color: '#666', mb: 0.5}}>
            Created
          </Typography>
          <Typography variant="body1">{dayjs(examModule.createdAt).format('MMM DD, YYYY')}</Typography>
        </Box>
      </Box>
    </Stack>
  );
}
